export enum FieldType {
  Boolean = 'boolean',
  Byte = 'byte',
  Date = 'date',
  Double = 'double',
  Float = 'float',
  HalfFloat = 'half_float',
  Integer = 'integer',
  Long = 'long',
  ScaledFloat = 'scaled_float',
  Short = 'short',
  String = 'string',
  Chips = 'chips',
  Select = 'select',
}
